export const SINGLE_LEVEL_MENU_THRESHOLD = 8;
export const TABLET_SINGLE_LEVEL_MENU_THRESHOLD = 7;

export const SECOND_LEVEL_MENU_THRESHOLD = 9;
export const TABLET_SECOND_LEVEL_MENU_THRESHOLD = 8;

export const OTHERS_CATEGORY_CODE = "others-category";
